import { useEffect, useState } from "react";

let deferredPrompt = null;

export default function usePWAInstall() {
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault(); // stop Chrome mini-infobar
      deferredPrompt = e;
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () =>
      window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const installApp = async () => {
    if (!deferredPrompt) {
      console.warn("Install prompt not ready yet");
      return;
    }

    // MUST be called from user click
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      deferredPrompt = null;
      setIsInstallable(false);
    }
  };

  return { isInstallable, installApp };
}
